module.exports = __webpack_public_path__ + "img/019_thumbnail.558d7207.jpg";